import { Buildings, Handshake } from "@phosphor-icons/react";
import { PickerItemProps } from "../../types";

interface BuildingData {
  id: string;
  owner?: boolean;
  acquisitionPhase?: string;
  company?: {
    name: string;
  };
}

export const BuildingItem = ({ item, isSelected, onSelect }: PickerItemProps<BuildingData>) => {
  const isAcquisition = item.owner === false;
  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-4 py-3 rounded-lg text-sm transition-all duration-200 border ${
        isSelected
          ? "bg-moss-primary/10 border-moss-primary/40 ring-2 ring-moss-primary/20 shadow-sm"
          : "border-neutral-primary/10 hover:border-neutral-primary/20 hover:bg-neutral-primary/5 hover:shadow-sm"
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="shrink-0 w-9 h-9 rounded-lg bg-neutral-primary/5 flex items-center justify-center">
          <Buildings className="h-5 w-5 text-neutral-primary/70" weight="duotone" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-neutral-primary truncate">{item.id}</span>
            {isAcquisition && (
              <span
                className="inline-flex items-center gap-1 shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-medium text-amber-800 border border-amber-200"
                title={
                  item.acquisitionPhase
                    ? `Nog niet in eigendom — acquisitiefase: ${item.acquisitionPhase}`
                    : 'Nog niet in eigendom (acquisitie)'
                }
              >
                <Handshake className="h-3 w-3" weight="bold" />
                Acquisitie
              </span>
            )}
          </div>
          {item.company?.name && (
            <div className="text-xs text-neutral-secondary-mid truncate mt-0.5">{item.company.name}</div>
          )}
        </div>
      </div>
    </button>
  );
};